import React from "react";
import { Route, Switch } from "react-router-dom";

import ExceptionPage from "./exception/ExceptionPage";
import NietGevondenPage from "./notFound/NietGevondenPage";
import NoAccessPage from "./noAccess/NoAccessPage";
import TestPage from "./TestPage";
import ParentHistoryComponent from "./common/ParentHistoryComponent";

import DemoPage from "./e-loket/demo/DemoPage";
import TochtPage from "./e-loket/tocht/TochtPage";
import UpdateTochtPage from "./e-loket/tocht/UpdateTochtPage";
import OrganisatorPage from "./e-loket/organisator/OrganisatorPage";
import ToelatingenPage from "./e-loket/toelatingen/ToelatingenPage";
import SamenvattingPage from "./e-loket/samenvatting/SamenvattingPage";
import GemeentePDFPage from "./e-loket/gemeentePDF/GemeentePDFPage";
import FederatieOverzichtPage from "./e-loket/federatieOverzicht/FederatieOverzichtPage";
import KalenderGoedkeurenPage from "./e-loket/kalenderGoedkeuren/KalenderGoedkeurenPage";
import VTTPerOrganisatorPage from "./e-loket/vttPerOrganisator/VTTPerOrganisatorPage";
import OrbMigratiePage from "./e-loket/orbMigratie/OrbMigratiePage";
import LusPage from "./e-loket/lus/LusPage";
import VTTPerGemeentePage from "./e-loket/vttPerGemeente/VTTPerGemeentePage";
import ToelatingPerGemeentePage from "./e-loket/toelatingPerGemeente/ToelatingPerGemeentePage";
import ZoekmotorOverzichtPage from "./zoekmotor/overzicht/OverzichtPage";
import ZoekmotorDetailPage from "./zoekmotor/detail/DetailPage";
import PublicatiePage from "./e-loket/publicatie/PublicatiePage";
import UitInVlaanderenPage from "./internal/uitInVlaanderen/UitInVlaanderenPage";
import AangemeldPage from "./e-loket/aangemeld/AangemeldPage";
import DeprecatedStartPage from "./e-loket/deprecatedStartPage/DeprecatedStartPage";
import SupportSpoVlaMedewerkerPage from "./e-loket/supportSpoVlaMedewerker/SupportSpoVlaMedewerkerPage";
import ConflictBeoordelingPage from "./e-loket/conflictBeoordeling/ConflictBeoordelingPage";
import AzureRoute from "./common/AzureRoute";

export const getRoutes = (match) => {

	return (
		<Switch>
			{/* Guarded routes*/}
			{/* Sport Vlaanderen medewerker */}
			<AzureRoute path={`${match.url}/backoffice/sportvlaanderenmedewerker`} component={SupportSpoVlaMedewerkerPage} />
			<AzureRoute path={`${match.url}/backoffice`} component={SupportSpoVlaMedewerkerPage} />
			<AzureRoute path={`${match.url}/internal/uitinvlaanderen`} component={UitInVlaanderenPage} redirectPath="internal/uitinvlaanderen" />
			<AzureRoute path={`${match.url}/testpage`} component={TestPage} redirectPath="testpage" />

			{/* Old */}
			<Route path={`${match.url}/e-loket/federatieoverzicht`} component={FederatieOverzichtPage} />
			<Route path={`${match.url}/e-loket/organisatoroverzicht`} component={VTTPerOrganisatorPage} />
			<Route path={`${match.url}/e-loket/orbmigratie`} component={OrbMigratiePage} />
			<Route path={`${match.url}/e-loket/gemeenteoverzicht`} component={VTTPerGemeentePage} />
			<Route path={`${match.url}/e-loket/federatieStart`} component={DeprecatedStartPage} />
			<Route path={`${match.url}/e-loket/gemeenteStart`} component={DeprecatedStartPage} />
			<Route exact path={`${match.url}/e-loket`} component={AangemeldPage} />

			{/* New */}
			{/* Demo */}
			<Route path={`${match.url}/e-loket/demo/:modelId/:isEdit?`} component={DemoPage} />
			<Route path={`${match.url}/e-loket/demo/new`} render={(props) => <DemoPage {...props} isNew />} />

			{/* Conflicten */}
			<Route path={`${match.url}/conflictbeoordeling/:gpxConflictId?`} component={ConflictBeoordelingPage} />

			{/* Organisator */}
			<Route path={`${match.url}/e-loket/organisator/:modelId/:herkomst/:isDisabled?`} component={OrganisatorPage} />
			<Route path={`${match.url}/e-loket/veldtoertochten`} component={VTTPerOrganisatorPage} />

			{/* Federatie */}
			<Route path={`${match.url}/e-loket/federatieOverzicht`} component={FederatieOverzichtPage} />
			<Route path={`${match.url}/e-loket/kalenderGoedkeuren/:provincieId?`} component={KalenderGoedkeurenPage} />

			{/* Gemeente */}
			<Route path={`${match.url}/e-loket/gemeente/veldtoertochten`} component={VTTPerGemeentePage} />
			<Route path={`${match.url}/e-loket/gemeente/toelating/:tochtId`} component={ToelatingPerGemeentePage} />
			<Route path={`${match.url}/e-loket/gemeente/pdf/:tochtId`} component={GemeentePDFPage} />

			{/* Tocht */}
			<Route path={`${match.url}/e-loket/veldtoertocht/nieuw`} component={TochtPage} />
			<Route path={`${match.url}/e-loket/veldtoertocht/clone/:tochtId`} component={TochtPage} />
			<Route path={`${match.url}/e-loket/veldtoertocht/:modelId`} component={UpdateTochtPage} />

			{/* Lus */}
			<Route path={`${match.url}/e-loket/lussen/:modelId/:lusId`} component={LusPage} />

			{/* Toelatingen */}
			<Route path={`${match.url}/e-loket/goedkeuringen/:modelId`} component={ToelatingenPage} />

			{/* Publicatie */}
			<Route path={`${match.url}/e-loket/publicatie/:modelId`} component={PublicatiePage} />

			{/* Samenvatting */}
			<Route path={`${match.url}/e-loket/samenvatting/:modelId`} component={SamenvattingPage} />

			{/* Redirect to NotFound */}
			<Route path={`${match.url}/e-loket/:aanmeldcode/demo/:modelId/:isEdit?`} render={(props) => <NietGevondenPage {...props} routeWithAanmeldCode />} />
			<Route path={`${match.url}/e-loket/:aanmeldcode/demo/new`} render={(props) => <NietGevondenPage {...props} routeWithAanmeldCode />} />
			<Route path={`${match.url}/e-loket/:accounttype/:aanmeldcode/veldtoertocht/nieuw`} render={(props) => <NietGevondenPage {...props} routeWithAanmeldCode />} />
			<Route path={`${match.url}/e-loket/:accounttype/:aanmeldcode/veldtoertocht/clone/:tochtId`} render={(props) => <NietGevondenPage {...props} routeWithAanmeldCode />} />
			<Route path={`${match.url}/e-loket/:accounttype/:aanmeldcode/organisator/:modelId/:herkomst/:isDisabled?`} render={(props) => <NietGevondenPage {...props} routeWithAanmeldCode />} />
			<Route path={`${match.url}/e-loket/:accounttype/:aanmeldcode/veldtoertocht/:modelId`} render={(props) => <NietGevondenPage {...props} routeWithAanmeldCode />} />
			<Route path={`${match.url}/e-loket/:accounttype/:aanmeldcode/lussen/:modelId/:lusId`} render={(props) => <NietGevondenPage {...props} routeWithAanmeldCode />} />
			<Route path={`${match.url}/e-loket/:accounttype/:aanmeldcode/goedkeuringen/:modelId`} render={(props) => <NietGevondenPage {...props} routeWithAanmeldCode />} />
			<Route path={`${match.url}/e-loket/:accounttype/:aanmeldcode/publicatie/:modelId`} render={(props) => <NietGevondenPage {...props} routeWithAanmeldCode />} />
			<Route path={`${match.url}/e-loket/:accounttype/:aanmeldcode/samenvatting/:modelId`} render={(props) => <NietGevondenPage {...props} routeWithAanmeldCode />} />
			<Route path={`${match.url}/e-loket/:federatieId/federatieOverzicht`} render={(props) => <NietGevondenPage {...props} routeWithAanmeldCode />} />
			<Route path={`${match.url}/e-loket/:federatieId/kalenderGoedkeuren/:provincieId?`} render={(props) => <NietGevondenPage {...props} routeWithAanmeldCode />} />
			<Route path={`${match.url}/e-loket/:organisatorId/veldtoertochten`} render={(props) => <NietGevondenPage {...props} routeWithAanmeldCode />} />
			<Route path={`${match.url}/e-loket/:gemeenteId/gemeente/veldtoertochten`} render={(props) => <NietGevondenPage {...props} routeWithAanmeldCode />} />
			<Route path={`${match.url}/e-loket/:gemeenteId/gemeente/toelating/:tochtId`} render={(props) => <NietGevondenPage {...props} routeWithAanmeldCode />} />
			<Route path={`${match.url}/e-loket/:gemeenteId/gemeente/pdf/:tochtId`} render={(props) => <NietGevondenPage {...props} routeWithAanmeldCode />} />

			<Route path={`${match.url}/zoekmotor/overzicht`} component={ZoekmotorOverzichtPage} />
			<Route path={`${match.url}/zoekmotor/detail/:tochtId`} component={ZoekmotorDetailPage} />
			<Route path={`${match.url}/zoekmotor/detail`} component={ZoekmotorDetailPage} />


			<Route path={`${match.url}/parentHistory/back`} component={ParentHistoryComponent} />
			<Route path={`${match.url}/parentHistory/path`} component={ParentHistoryComponent} />
			<Route path={`${match.url}/exception`} component={ExceptionPage} />
			<Route path={`${match.url}/noAccess`} component={NoAccessPage} />

			<Route exact path={`${match.url}`} component={AangemeldPage} />
			<Route exact path={`${match.url}/`} component={AangemeldPage} />
			<Route path={`${match.url}/aangemeld/:keuze?`} component={AangemeldPage} />
			<Route path={`${match.url}/*`} component={NietGevondenPage} />
		</Switch>
	);
};
